// extracted by mini-css-extract-plugin
module.exports = {"pillsContainer":"styles_pillsContainer__10Jgj"};